export const API_URL = "https://api.evercalmmenopause.com/";
// export const API_URL = "http://localhost:3001";

export * as Options from "./options";
